import React from "react";
import { createPortal } from "react-dom";

export function PortalTooltip({
  children,
  className = "",
  style = {},
  ...props
}) {
  return createPortal(
    <div className={`absolute z-[9999] ${className}`} style={style} {...props}>
      {children}
    </div>,
    document.body,
  );
}
